import { addStyles } from 'ethcss'
import { mediaCSS } from 'theme/media'
import { grid, IStyles, item } from '../../theme'
import { colors } from 'theme'

const scheduleStyles: IStyles = {
    checkbox: {
        [mediaCSS.tabMini]: {
            ...item.none,
        },
    },
    checkboxWrapper: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.justify,
        marginTop: 3,
    },
    fullBlockCheckboxWrapper: {
        ...grid.row,
        ...grid.full,
        ...grid.normalCenter,
        ...grid.center,
    },
    scheduleWrapper: {
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
    wrapperClassName: {
        zIndex: 99,
        background: `var(--var-module-app-component-content-style-background, #FFFFFF)`,
    },
    wrap: {
        whiteSpace: 'normal !important',
    },
    eventContent: {
        display: 'flex',
        alignItems: 'center',
    },
    priority: {
        width: 2,
        height: 20,
        marginRight: 8,
    },
    priorityHigh: {
        backgroundColor: colors.highPriority,
    },
    priorityMedium: {
        backgroundColor: colors.warning,
    },
    priorityLow: {
        backgroundColor: colors.blueAccent,
    },
    title: {
        width: 'calc(100% - 2px)',
        overflow: 'hidden',
    },
}

addStyles(scheduleStyles)
export default scheduleStyles
